import React from 'react'
interface HamburgerProps {
  className?: string
}
const HamburgerImg = ({ className = 'black' }: HamburgerProps) => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z"
        fill="currentColor"
        className={className}
      />
    </svg>
  )
}

export default HamburgerImg
